import { splitWhere } from './group';
import { MINUTE_MS } from './time';

const SESSION_GAP_MS = 30 * MINUTE_MS;
const SESSION_RADIUS_M = 200;
const EARTH_RADIUS_M = 6_371_000;

export interface Located {
  readonly time: number;
  readonly latitude: number | undefined;
  readonly longitude: number | undefined;
}

interface Point {
  readonly latitude: number;
  readonly longitude: number;
}

const radians = (degrees: number): number => (degrees * Math.PI) / 180;

const isPoint = (place: Located): place is Located & Point => place.latitude !== undefined && place.longitude !== undefined;

export function distanceM(a: Point, b: Point): number {
  const dLat = radians(b.latitude - a.latitude);
  const dLon = radians(b.longitude - a.longitude);
  const h = Math.sin(dLat / 2) ** 2 + Math.cos(radians(a.latitude)) * Math.cos(radians(b.latitude)) * Math.sin(dLon / 2) ** 2;
  return 2 * EARTH_RADIUS_M * Math.asin(Math.sqrt(h));
}

const moved = (a: Located, b: Located): boolean => isPoint(a) && isPoint(b) && distanceM(a, b) > SESSION_RADIUS_M;

export const groupSessions = <E extends Located>(events: readonly E[]): readonly (readonly E[])[] =>
  splitWhere(
    [...events].sort((a, b) => a.time - b.time),
    (previous, event) => event.time - previous.time > SESSION_GAP_MS || moved(previous, event),
  );
